
import React, { Fragment } from 'react';

// Component

import SummaryItem from '../SummaryItem';

const LanguageInfo = props => {

    const {
        languageDescriptors: [
            preferredSpokenLanguageDescriptor,
            preferredWrittenLanguageDescriptor
        ],
        values: [
            preferredSpokenLanguageValue,
            preferredWrittenLanguageValue
        ]
    } = props;

    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.preferred_spoken_language'
                desc = { preferredSpokenLanguageDescriptor }
                value = { preferredSpokenLanguageValue }
            />

            <SummaryItem
                textCode = 'common.preferred_written_language'
                desc = { preferredWrittenLanguageDescriptor }
                value = { preferredWrittenLanguageValue }
            />
        </Fragment>
    );
};

export default LanguageInfo;